import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SalesService } from './sales-service.service';
import { StoreService } from './../store-view/store-service.service';
import { Chart } from 'angular-highcharts';
import { Angular2Csv } from 'angular2-csv/Angular2-csv';
import { DecimalPipe, DatePipe } from '@angular/common';
import { Configuration } from '../../Configuration';
import { AppService } from '../../app.service';
import * as moment from 'moment';
import 'rxjs/add/operator/map';
import { IMultiSelectOption, IMultiSelectTexts, IMultiSelectSettings } from 'angular-2-dropdown-multiselect';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';


@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.css']
})
export class SummaryComponent implements OnInit {

  public events: any = {};
  apptext: string;
  public competitor: boolean;
  public data;
  public mapdata;
  public categoryList;
  public filterdata = [];
  public mapCategoryList;
  meezanIndex: string;
  categoryIndex: string;
  listchk: string;
  public categoryCB: boolean = true;
  public filterFileData;
  public branchData = [];
  public section;
  public category = [];
  optionsModel = [];
  meezanModel = [];
  public allowMap = false;
  public allowExport = false;
  isLoad = true;

  myOptions: IMultiSelectOption[];
  meezanList: IMultiSelectOption[];

  checkoptions = [
    { class: 'fa fa-trademark fa-4x', src: 'https://png.icons8.com/ios/40/000000/business-filled.png', value: 'Business', name: 'business', checked: true, list: { "featureType": "poi.business", "stylers": [{ "visibility": "off" }] } },
    { class: 'fa fa-shirtsinbulk fa-4x', src: 'https://png.icons8.com/ios/40/000000/shopping-cart-filled.png', value: 'Attraction', name: 'attraction', checked: true, list: { "featureType": "poi.attraction", "stylers": [{ "visibility": "off" }] } },
    { class: 'fa fa-university fa-4x', src: 'https://png.icons8.com/ios/40/000000/hospital-3-filled.png', value: 'Park', name: 'Park', checked: true, list: { "featureType": "poi.park", "stylers": [{ "visibility": "off" }] } },
    { class: 'fa fa-building-o fa-4x', src: 'https://png.icons8.com/ios/40/000000/company-filled.png', value: 'Govt building', name: 'government', checked: true, list: { "featureType": "poi.government", "stylers": [{ "visibility": "off" }] } },
    { class: 'fa fa-hospital-o fa-4x', src: 'https://png.icons8.com/ios/40/000000/hospital-3-filled.png', value: 'Medical', name: 'medical', checked: true, list: { "featureType": "poi.medical", "stylers": [{ "visibility": "off" }] } },
    { class: 'fa fa-hand-paper-o fa-4x', src: 'https://png.icons8.com/metro/40/000000/mosque.png', value: 'Worship', name: 'place_of_worship', checked: true, list: { "featureType": "poi.place_of_worship", "stylers": [{ "visibility": "off" }] } },
    { class: 'fa fa-graduation-cap fa-4x', src: 'https://png.icons8.com/dotty/40/000000/graduation-cap.png', value: 'School', name: 'school', checked: true, list: { "featureType": "poi.school", "stylers": [{ "visibility": "off" }] } },
    { class: 'fa fa-cc-diners-club fa-4x', src: 'https://png.icons8.com/ios/40/000000/sports-mode-filled.png', value: 'Sports', name: 'sports_complex', checked: true, list: { "featureType": "poi.sports_complex", "stylers": [{ "visibility": "off" }] } }
  ]

  mySettings: IMultiSelectSettings = {
    enableSearch: true,
    checkedStyle: 'fontawesome',
    buttonClasses: 'btn btn-block bcc',
    dynamicTitleMaxItems: 2,
    displayAllSelectedText: true,
    showCheckAll: true,
    containerClasses: 'jh',
    showUncheckAll: true,

  };

  myTexts: IMultiSelectTexts = {
    checkAll: 'Select all',
    uncheckAll: 'Unselect all',
    checked: 'item selected',
    checkedPlural: 'items selected',
    searchPlaceholder: 'Find',
    searchEmptyResult: 'No Selection Found',
    searchNoRenderText: 'Industries...',
    defaultTitle: 'Select Industry',
    allSelected: 'All selected',
  };

 
  mySettingsMeezan: IMultiSelectSettings = {
    enableSearch: true,
    checkedStyle: 'fontawesome',
    buttonClasses: 'btn btn-block   bcc',
    dynamicTitleMaxItems: 2,
    displayAllSelectedText: true,
    containerClasses: 'jh',
    showCheckAll: true,
    showUncheckAll: true,

  };


  myTextsMeezan: IMultiSelectTexts = {
    checkAll: 'Select all',
    uncheckAll: 'Unselect all',
    checked: 'item selected',
    checkedPlural: 'items selected',
    searchPlaceholder: 'Find',
    searchEmptyResult: 'No Selection Found',
    searchNoRenderText: 'Meezan branches...',
    defaultTitle: 'Select Branch',
    allSelected: 'All selected'
  };



  constructor(public router: Router, public Service: SalesService, private config: Configuration, private datepipe: DatePipe, private api: AppService) {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
  }


  onChangeMeezan(){
    var mcount = this.meezanModel.length;
    var ccount = this.optionsModel.length;
    if (mcount > 0 && ccount > 0) {
      this.allowMap = true;
      this.allowExport = true;
    }
    else {
      this.allowMap = false;
      this.allowExport = false;
    }
  }
  onChange() {
    var count = this.optionsModel.length; 
    if (count > 0) {
      this.allowMap = true;
      this.allowExport = true;
    }
    else {
      this.allowMap = false;
      this.allowExport = false;
    }
  }
  checkVal(event: any){
    if(event.target.checked == false)
    {
      this.categoryCB = false
    }
    if(event.target.checked == true)
    {
      let temp = true;
      this.checkoptions.forEach(x=>{
        if(x.checked == true)
        {
          temp = true
        }
        else{
          temp = false
        }
        this.categoryCB = temp
      }); 
    }

  }
  checkValue(event: any){
    if(this.categoryCB == true)
    {
      this.checkoptions.forEach(x=>{x.checked = true}); 
    }
    else
    {this.checkoptions.forEach(x=>{x.checked = false}); }
  }


  refreshddl(){
    this.optionsModel = [];
    this.meezanModel =[];
    this.allowMap = false;
    this.allowExport = false;
    this.categoryCB = true;
    this.checkValue(true);
    this.competitor = true;
  }

 

  ngOnInit() {
    if((!!localStorage.getItem('User') == true))
    {
      if (!!localStorage.getItem('data') == true) {
        let branch = JSON.parse(localStorage.getItem('data'));
        this.competitor = branch.compet;
        this.meezanModel = branch.branch;
        this.optionsModel = branch.categorymap;
        this.checkoptions = branch.builtinCat;
        let t =[], f=[];
        this.checkoptions.forEach(x=>{

          let temp = true;
          if(x.checked == true)
          {
            temp = true;
            t.push(temp);
          }
          else{
            temp = false;
            f.push(temp);
          }
        });
   
        if(t.length == 8)
          {
           this.categoryCB = true;
          }
          else
          {
            this.categoryCB = false;
          } 
      }

      this.competitor = true;
      this.isLoad = false;
      this.events.getSummary = this.Service.getFilter().subscribe(result => {
        
        var branchDataa = result[0]['branch_name'];
        this.section = result[1]['Section'];
        this.section.map(d => {
          if(d.Section != '' && d.Section != null)
            {
              this.category.push({ id: d.Section, name: d.Section })
            }
        }
        )
        branchDataa.map(d => {
          this.branchData.push({ id: d.branch_id, name: d.branch_name, lat: d.branch_latitude, lng: d.branch_longitude })
        }
        )
        this.ddlMeezan();
        this.ddlCategory();
        this.isLoad = true;
      });
    }
  
  else
  {
    this.router.navigate(['/login']);
  }

  }

deSelectCategory(){
  this.optionsModel =[];
  this.onChange()
}
deSelectMeezan(){
  this.meezanModel =[];
  this.onChangeMeezan();
}

  ngOnDestroy() {
    this.unsubscribeEvents();
  }

  unsubscribeEvents() {
    Object.keys(this.events).forEach(key => this.events[key].unsubscribe());
    this.events = {};
  }
  ddlMeezan() {
    this.meezanList = this.branchData;
  }
  ddlCategory() {
    this.myOptions = this.category;
  }

 

  onMapGenerate() {
    var branch = this.meezanModel;
    let branchCount = this.branchData.length;
    let sectionCount = this.category.length;
    var categorymap = this.optionsModel;
    var builtinCat = this.checkoptions;
    var compet = this.competitor;
    localStorage.setItem('data', JSON.stringify({branch, categorymap, builtinCat, compet, sectionCount,branchCount }));
    this.router.navigate(['/Map']);
  }


  exportPDF() {
    this.isLoad = false;
    let pdfBName = "";
    let bIdStr = "";
    if (this.meezanModel.length == this.branchData.length) {bIdStr = "205"; pdfBName = "ALL"}
    else 
    {
      this.meezanModel.map(w => {
        bIdStr = bIdStr + "," + w ;
        let tempData = this.branchData.filter(x => x.id == w);
        pdfBName = pdfBName + ',' + tempData[0]['name'];
      })
      bIdStr = bIdStr.substr(1);
      pdfBName = pdfBName.substr(1);  
     
    }
    var ct = this.optionsModel;

    let ctname = "";
    if(this.optionsModel.length == this.category.length){ctname = "ALL";}
    else
    {
    ct.map(w => {
      ctname = ctname + "," + w
    })
    ctname = ctname.substr(1);
  }

    var pdfData = [
      [
        { text: 'Name', bold: true }, 
        { text: 'Address', bold: true },
        { text: 'Telephone', bold: true }, 
        { text: 'Industry', bold: true }
      ]
    ];
      this.events.getSummary = this.Service.getBranchData(bIdStr, ctname).subscribe(result => {
       this.filterdata = result[1]['Sections'];
        this.filterdata.map(d => {
          let arrt = [];
          arrt.push(d.Name);
          arrt.push(d.Address);
          arrt.push(d.Telephone);
          arrt.push(d.Section);
          pdfData.push(arrt);
        })
        this.pdfGenerate(pdfData, pdfBName);
        this.isLoad = true;
        this.refreshddl();
      });
    
  }
  pdfGenerate(data, name) {

    var docDefinition = {
      pageMargins: [15, 50, 15, 40],
      content: [
        {
          layout: 'lightHorizontalLines', // optional
          table: {
            headerRows: 1,
            widths: ['*', 'auto', 100, '*'],
            body: data
          }
        }
      ],
      header: {
        margin: 10,
        columns: [
          {
            margin: [5, 20, 0, 0],
            text: 'Branch Name : ' + name
          },
          {
            margin: [0, 0, 0, 0],
            text: 'Buisness Details',
            fontSize: 14,
          },
          {
            image: 'data:image/png;base64,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',
            width: 60
          },
        ]
      },
      footer: function (currentPage, pageCount) {
        return {
          columns: [
            "Page: " + currentPage.toString() + ' of ' + pageCount,
            {
              text: 'Selected businesses are within 5 kilometers range of the branch',
              alignment: 'center',
              fontSize: 6
            },
            {
              text: moment(Date.now(), 'x').format('MM/DD/YYYY'),
              alignment: 'right'
            }
          ],
          margin: [25, 10, 25, 0],
          fontSize: 8
        }
      },
      styles: {
        header: {
          bold: true,
          alignment: 'justify',
          margin: [0, 40, 0, 40]
        },
        table: {
          margin: [0, 40, 0, 0]
        },
        money: {
          alignment: 'right'
        },
        tableHeader: {
          bold: true
        },
        tableHeaderRight: {
          alignment: 'right',
          bold: true
        }
      },
      tableLayouts: {
        accounting: {
          hLineWidth: function (i, node) {
            return .5;
          },
          vLineWidth: function (i, node) {
            return 0;
          },
          hLineColor: function (i, node) {
            return i === (node.table.body.length - 1) ? 'gray' : 'white';
          },
          vLineColor: function (i, node) {
            return 'white';
          }
        }
      },
      defaultStyle: {
        fontSize: 8,
      }
    };

    pdfMake.createPdf(docDefinition).download('BuisnessDetails.pdf');
  }


}



// WEBPACK FOOTER //
// ./src/app/home-page/sales-forecast/summary.component.ts